<h2 mat-dialog-title class="flex items-center gap-3 text-xl font-bold mb-4 px-6 py-4 border-b">
  <mat-icon class="text-blue-600">visibility</mat-icon>
  <span>Logo de {{ data.companyName }}</span>
</h2>

<mat-dialog-content class="!px-0 !py-0">
  <div class="p-5">
    <!-- Logo Display -->
    <div class="flex justify-center p-6 bg-gray-50 rounded-lg border-2 border-gray-200">
      <img
        [src]="data.currentLogoUrl"
        [alt]="'Logo de ' + data.companyName"
        class="max-h-96 max-w-full object-contain rounded shadow-lg"
        (error)="$event.target.src = 'assets/images/placeholder-logo.png'"
      >
    </div>

    <!-- Company Info -->
    <div class="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div class="flex items-center gap-3">
        <mat-icon class="text-blue-600">business</mat-icon>
        <div>
          <p class="font-medium text-blue-800">{{ data.companyName }}</p>
          <p class="text-sm text-blue-600">ID: {{ data.companyId }}</p>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end gap-3 px-6 py-4 border-t">
  <button
    mat-raised-button
    color="primary"
    (click)="close()"
    class="bg-blue-600 text-white"
  >
    <mat-icon class="mr-1">close</mat-icon>
    Cerrar
  </button>
</mat-dialog-actions>